import { type FC, useEffect, useState } from 'react';
import { withCloudflareVariant } from '../common/utilities/cdnImage';

interface Props {
  src: string;
  alt: string;
  className?: string;
  variant?: string;
}

const CdnImage: FC<Props> = ({ src, alt, className, variant }) => {
  const originalUrl = src.trim();
  const preferredUrl = variant
    ? withCloudflareVariant(originalUrl, variant)
    : originalUrl;
  const [currentSrc, setCurrentSrc] = useState(preferredUrl);

  useEffect(() => {
    setCurrentSrc(preferredUrl);
  }, [preferredUrl]);

  if (!originalUrl) {
    return null;
  }

  const handleError = () => {
    if (currentSrc !== originalUrl) {
      setCurrentSrc(originalUrl);
    }
  };

  return (
    <img
      className={className}
      src={currentSrc}
      alt={alt}
      onError={handleError}
    />
  );
};

export default CdnImage;
